import { render } from "./OfficialClient.vue?vue&type=template&id=32a834b8&scoped=true"
import script from "./OfficialClient.vue?vue&type=script&lang=js"
export * from "./OfficialClient.vue?vue&type=script&lang=js"

import "./OfficialClient.vue?vue&type=style&index=0&id=32a834b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a834b8"]])

export default __exports__